var _circle, _circle2, _circle3, _circle4, _circle5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgmV2 = function SvgBgmV2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 334,
    viewBox: "0 0 320 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 247.672,
    cy: 264.028,
    r: 69.6371,
    fill: "#F9B233"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 45.5,
    r: 95.5,
    fill: "#FE5F42"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.222,
    cy: 149.222,
    r: 45.222,
    fill: "#4D4D4D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 12.5,
    r: 24.5,
    fill: "#9B51E0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -9,
    cy: 55,
    r: 158,
    fill: "#0060BF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgmV2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bgm_v2.b19ae9ab2909dca6ab135d752de78d08.svg";